/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_V2_No_MatchInputs */

const en_notes_v2_no_match = /** @type {(inputs: Notes_V2_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No notes match your filter`)
};

const es_notes_v2_no_match = /** @type {(inputs: Notes_V2_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ninguna nota coincide con el filtro`)
};

/**
* | output |
* | --- |
* | "No notes match your filter" |
*
* @param {Notes_V2_No_MatchInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const notes_v2_no_match = /** @type {((inputs?: Notes_V2_No_MatchInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_V2_No_MatchInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_notes_v2_no_match(inputs)
	return en_notes_v2_no_match(inputs)
});